/*global define, console, window, HTMLImageElement, Promise*/
(window.MyModule = function ($, Behaviors) {
    "use strict";
    var module = {};
    function JonathanGreenCalltoActionCards(elem) {
        Behaviors.init(JonathanGreenCalltoActionCards, this, arguments);
        var $thisElem = this.$elem;

        



    }
    Behaviors.inherit(JonathanGreenCalltoActionCards, Behaviors.Behavior);
    JonathanGreenCalltoActionCards.QUERY = "[data-JonathanGreenCalltoActionCards]";
    JonathanGreenCalltoActionCards.ELEMENTS = {
        loadMoreButton: ".AwardTabs-content_tabs_items_item_loadMore__button",
    };
    Behaviors.register_behavior(JonathanGreenCalltoActionCards);
    module.JonathanGreenCalltoActionCards = JonathanGreenCalltoActionCards;
    return module;
}(window.jQuery, window.Behaviors));
